<template>
  <div class="header-container flex flex-row items-center justify-center">
    <div class="header-container__item flex flex-row items-center justify-between">
      <div class="item-child flex flex-row items-center">
        <img
          height="70"
          width="90"
          src="../../../assets/logo1.jpg"
          alt
        />
        <h2>吉首市城市供水总公司</h2>
      </div>
      <div class="item-child-right flex flex-column justify-between">
        <div class="flex flex-row items-center">
          <img
            src="../../../assets/tel.jpg"
            width="40"
            height="40"
          />
          <div class="flex flex-column" style="margin-left:10px;">
            <h3>服务热线</h3>
            <h4>0743-8222184</h4>
          </div>
        </div>
        <ul>
          <li>专业</li>
          <li>高效</li>
          <li>优质</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-header"
};
</script>

<style lang="scss" scoped>
.header-container {
  &__item {
    .item-child-right {
      ul {
        li {
          float: left;
          list-style: none;
          background: url('../../../assets/wuxing.jpg')
            no-repeat 0px 7px;
          padding-left: 20px;
          margin-right: 20px;
          line-height: 2;
          font-size: 16px;
        }
        display: inline-block;
      }
      h4 {
        font-style: normal;
        font-size: 20px;
        color: #337ab7;
        float: left;
        font-family: arial;
      }
      h3 {
        text-align: left;
        font-style: normal;
        font-size: 12px;
        color: #666;
        float: left;
      }
      max-width: 220px;
      float: right;
    }
    .item-child {
      h2 {
        color: rgb(51, 122, 183);
        font-size: 34px;
        line-height: 1;
        font-family: 微软雅黑;
      }

      width: auto;
      height: 100%;
    }
    width: 1200px;
    height: 100%;
  }
  width: 100%;
  height: 110px;
}
</style>


// WEBPACK FOOTER //
// src/components/front/header/Header.vue